import React from 'react';
import {FormattedMessage} from 'react-intl';
import PriceSummary from '@homeaway/react-price-summary';
import './Price.less';

export const listingHasPrice = (listing) => {
    const {priceSummary} = listing || {};
    return !!priceSummary;
};

export function Price({listing}) {
    if (listingHasPrice(listing)) {
        return <PriceSummary priceSummary={listing.priceSummary} />;
    }

    return (
        <span className="Price Price--noPrice" data-wdio="Price" data-price="0">
            <FormattedMessage
                id={'ratesNone'}
                description={'no price'}
                defaultMessage={'View details for price'}
            >
                {(txt) => <span className="Price__Fallback">{txt}</span>}
            </FormattedMessage>
        </span>
    );
}
